import React from "react";
import "./Notification.scss";
import Tabination from "../../reusableComponents/Tabination";
import BrokerNotification from "./BrokerNotification";
import UserNotification from "./UserNotification";

const Notification = () => {
  const tabItems = [
    {
      name: "User Notification",
      content: (
        <div className="traderslist notification-specific">
          <UserNotification />
        </div>
      ),
    },
    {
      name: "Broker Notification",
      content: (
        <div className="traderslist notification-specific">
          <BrokerNotification />
        </div>
      ),
    },
  ];

  return (
    <div className="notification-page-wrapper">
      <Tabination variant={3} tabItems={tabItems} activeTab={0} />
    </div>
  );
};

export default Notification;

